// extracted by mini-css-extract-plugin
export var chip = "_d1-0";
export var filterDropdown = "_d1-5";
export var filterItem = "_d1-6";
export var icon = "_d1-1";
export var removeButton = "_d1-3";
export var removeIcon = "_d1-4";
export var separator = "_d1-2";